var WDN = WDN || {};

if (typeof WDN.VideoModal === "undefined") {
  WDN.VideoModal = (function () {
    class VideoModal extends HTMLElement {
      constructor() {
        super();
        this.isPlaying = false;
        this.isMuted = false;

        this.escClickHandlerBound = this.escClickHandler.bind(this);
      }

      openModal() {
        this.classList.add("videomodal--open");
        this.registerEscClick();
      }

      closeModal() {
        this.classList.remove("videomodal--open");
        this.player.innerHTML = "";
        this.unregisterEscClick();
      }

      escClickHandler(e) {
        if (e.key == "Escape") {
          this.closeModal();
        }
      }

      registerEscClick() {
        document.body.addEventListener("keydown", this.escClickHandlerBound);
      }

      unregisterEscClick() {
        document.body.removeEventListener("keydown", this.escClickHandlerBound);
      }

      addVideo(videoHTML) {
        this.player.innerHTML = "";
        this.muteBtn.removeAttribute("data-muted");
        this.playbackToggler.removeAttribute("data-is-paused");
        this.isPlaying = true;
        this.player.prepend(videoHTML);

        this.player.querySelector("video").play();
      }

      muteToggle() {
        if (this.isMuted) {
          this.player.querySelector("video").muted = false;
          this.player.querySelector("video").removeAttribute("muted");
          this.muteBtn.removeAttribute("data-muted");
          this.isMuted = false;
        } else {
          this.player.querySelector("video").muted = true;
          this.player.querySelector("video").setAttribute("muted", "");
          this.muteBtn.setAttribute("data-muted", "");
          this.isMuted = true;
        }
      }

      togglePlayback() {
        if (this.isPlaying) {
          this.playbackToggler.setAttribute("data-is-paused", "");
          this.player.querySelector("video").pause();
          this.isPlaying = false;
        } else {
          this.playbackToggler.removeAttribute("data-is-paused");
          this.player.querySelector("video").play();
          this.isPlaying = true;
        }
      }

      attachVideoControls() {
        this.muteBtn = this.querySelector('button[name="mute"]');
        this.muteBtn.addEventListener("click", () => this.muteToggle());

        this.closeBtn = this.querySelector('button[name="close"]');
        this.closeBtn.addEventListener("click", () => this.closeModal());

        this.playbackToggler = this.querySelector(
          'button[name="playback-toggle"]'
        );
        this.playbackToggler.addEventListener("click", () =>
          this.togglePlayback()
        );
      }

      connectedCallback() {
        this.player = this.querySelector(".player");
        this.attachVideoControls();
      }
    }

    customElements.define("videomodal-player", VideoModal);

    return VideoModal;
  })();
}

if (typeof WDN.VideoModalTrigger === "undefined") {
  WDN.VideoModalTrigger = (function () {
    class VideoModalTrigger extends HTMLElement {
      constructor() {
        super();
      }

      onTriggerClick() {
        this.videoMarkup =
          this.querySelector("template").content.cloneNode(true);

        this.videoplayerModal =
          document.body.querySelector("videomodal-player");

        this.videoplayerModal.openModal();
        this.videoplayerModal.addVideo(this.videoMarkup);
      }

      connectedCallback() {
        if (this.querySelector("template")) {
          this.addEventListener("click", () => this.onTriggerClick());
        }
      }
    }

    customElements.define("videomodal-trigger", VideoModalTrigger);

    return VideoModalTrigger;
  })();
}
